import { useInvitationCheck } from "@/hooks/useInvitationCheck";

/**
 * Composant qui vérifie et accepte automatiquement les invitations en attente
 * 
 * Monté globalement dans l'app pour couvrir toutes les routes.
 * Le hook interne gère:
 * - La détection du token d'invitation dans l'URL
 * - L'appel à l'edge function pour accepter l'invitation
 * - Le nettoyage de l'URL après traitement
 * - L'idempotence (déjà membre = OK)
 */
export function InvitationHandler() {
  useInvitationCheck();
  return null;
}
